module.exports = __webpack_public_path__ + "img/b2.ea58388.png";